import React, { useState, useEffect } from "react";
import { BASE_URL } from "../env";
import { useHistory } from "react-router-dom";
const CoursesDashboard = () => {
	const history = useHistory();
	const [courses, setCourses] = useState([]);
	const [courseData, setCourseData] = useState({});
	const [course, setcourse] = useState("");

	useEffect(() => {
		fetch(BASE_URL + "/getallCourse")
			.then((res) => res.json())
			.then((data) => {
				setCourses(data?.courses);
			});
	}, []);

	useEffect(() => {
		const test = courses.filter((data) => data._id == course);
		console.log(test);
		history.push({
			pathname: `/coursesdashboard/${course}`,
			state: test,
		});
	}, [course]);

	return (
		<div className="text-center my-5">
			<h1>Select the course</h1>
			{/* <div className='d-flex justify-content-center flex-row'>
				<select
					name=''
					id=''
					value={course}
					onChange={(e) => {
						setcourse(e.target.value);
					}}>
					<option value=''>Select Course</option>
					{courses.map((val) => {
						return <option value={val?._id}>{val?.name}</option>;
					})}
				</select>
			</div> */}

			<div className="container">
				{courses.map((val) => {
					return (
						<div className="p-4 border m-3 rounded shadow">
							<p className="text-start fs-5">{val.name}</p>
							<div className="d-flex justify-content-end">
								<button
									type="button"
									class="btn btn-primary"
									onClick={() => {
										setcourse(val._id);
									}}
								>
									View More
								</button>
							</div>
						</div>
					);
				})}
			</div>
		</div>
	);
};

export default CoursesDashboard;
